import moment from 'moment';

/* eslint-disable import/prefer-default-export */
export class TravelMockProvider {
  pojos = [
    {
      fecha: '03/05/2021',
      concepto: 'EROSKI BILBONDO',
      importe: -29.9,
      puntos: null,
    },
    {
      fecha: '03/05/2021',
      concepto: 'EROSKI ARTEA',
      importe: -36.0,
      puntos: null,
    },
    {
      fecha: '03/05/2021',
      concepto: 'PUNTOS EXTRA',
      importe: null,
      puntos: null,
    },
    {
      fecha: '03/05/2021',
      concepto: 'EROSKI BERANGO',
      importe: -173.4,
      puntos: null,
    },
    {
      fecha: '03/05/2021',
      concepto: 'PUNTOS EXTRA',
      importe: null,
      puntos: null,
    },
    {
      fecha: '03/05/2021',
      concepto: 'HIPERMERCADO EROSKI BALLONTI',
      importe: -43.96,
      puntos: null,
    },
    {
      fecha: '03/05/2021',
      concepto: 'PUNTOS EXTRA',
      importe: null,
      puntos: null,
    },
    {
      fecha: '03/05/2021',
      concepto: 'EROSKI BOULEVARD',
      importe: -79.92,
      puntos: null,
    },
    {
      fecha: '03/05/2021',
      concepto: 'EROSKI LEIOA',
      importe: -29.9,
      puntos: null,
    },
    {
      fecha: '02/05/2021',
      concepto: 'EROSKI VÉLEZ-MALAGA',
      importe: -189.0,
      puntos: null,
    },
    {
      fecha: '01/05/2021',
      concepto: 'GASOLINERA URBIL',
      importe: 30.0,
      puntos: 4,
    },
    {
      fecha: '01/05/2021',
      concepto: 'EROSKI/center CALA RATJADA',
      importe: 23.5,
      puntos: 4,
    },
    {
      fecha: '01/05/2021',
      concepto: 'Rapid Vilanova',
      importe: 44.5,
      puntos: 8,
    },
    {
      fecha: '01/05/2021',
      concepto: 'NOMBRE LARGO GENERICO',
      importe: 5.42,
      puntos: 0,
    },
    {
      fecha: '01/05/2021',
      concepto: 'EROSKI/center SYP  PORTIXOL',
      importe: 40.8,
      puntos: 8,
    },
    {
      fecha: '01/05/2021',
      concepto: 'EROSKI/center ANDRATX',
      importe: 86.41,
      puntos: 16,
    },
    {
      fecha: '01/05/2021',
      concepto: 'EROSKI/center CALA RATJADA',
      importe: 1.35,
      puntos: 0,
    },
    {
      fecha: '01/05/2021',
      concepto: 'GASOLINERA BILBONDO',
      importe: 10.0,
      puntos: 0,
    },
    {
      fecha: '01/05/2021',
      concepto: 'EROSKI/center PORTO COLOM',
      importe: 10.92,
      puntos: 0,
    },
    {
      fecha: '01/05/2021',
      concepto: 'GASOLINERA LUGO',
      importe: 30.01,
      puntos: 4,
    },
    {
      fecha: '01/04/2021',
      concepto: 'EROSKI/center A BARCALA',
      importe: 37.25,
      puntos: 4,
    },
    { fecha: '01/04/2021', concepto: 'Ci.Frq.Barro', importe: 9.45, puntos: 0 },
    {
      fecha: '01/04/2021',
      concepto: 'EROSKI/center COBIAN AREAL',
      importe: 45.51,
      puntos: 8,
    },
    {
      fecha: '01/04/2021',
      concepto: 'EROSKI/center BARCELONA',
      importe: 39.35,
      puntos: 4,
    },
    {
      fecha: '01/04/2021',
      concepto: 'FAMILIA Vazquez de Parga',
      importe: 54.18,
      puntos: 8,
    },
    {
      fecha: '01/04/2021',
      concepto: 'EROSKI/ city Miño',
      importe: 50.98,
      puntos: 8,
    },
    {
      fecha: '01/04/2021',
      concepto: 'EROSKI/center Verin-Luis Espada',
      importe: 1.54,
      puntos: 0,
    },
    { fecha: '01/04/2021', concepto: 'EROSKI ELCHE', importe: 9.63, puntos: 0 },
    {
      fecha: '01/04/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/04/2021',
      concepto: 'EROSKI/center PORTANET',
      importe: 6.72,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/03/2021',
      concepto: 'Compra Familia',
      importe: null,
      puntos: 0,
    },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI/center AVD. NAVARRA',
      importe: 4.85,
      puntos: 0,
    },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI/center BALMASEDA',
      importe: 4.91,
      puntos: 0,
    },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI/center BASAURI',
      importe: 22.87,
      puntos: 4,
    },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI ZALLA',
      importe: 10.31,
      puntos: 0,
    },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI/city ATXURI',
      importe: 11.72,
      puntos: 0,
    },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI ZALLA',
      importe: 51.83,
      puntos: 8,
    },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI/center BALMASEDA',
      importe: 22.84,
      puntos: 4,
    },
    { fecha: '01/02/2021', concepto: 'EROSKI ZALLA', importe: 7.53, puntos: 0 },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI/center ORIXE (S. IGNACIO)',
      importe: 7.24,
      puntos: 0,
    },
    {
      fecha: '01/02/2021',
      concepto: 'EROSKI/center BALMASEDA',
      importe: 23.06,
      puntos: 4,
    },
    {
      fecha: '01/01/2021',
      concepto: 'GASOLINERA BILBONDO',
      importe: 30.0,
      puntos: 4,
    },
    {
      fecha: '31/12/2020',
      concepto: 'PUNTOS EXTRA',
      importe: null,
      puntos: 11,
    },
    {
      fecha: '31/12/2020',
      concepto: 'EROSKI/center LA PUEBLA',
      importe: 11.28,
      puntos: 0,
    },
    {
      fecha: '01/01/2021',
      concepto: 'GASOLINERA GORLIZ',
      importe: 20.0,
      puntos: 4,
    },
    {
      fecha: '01/01/2021',
      concepto: 'GASOLINERA MERKATONDOA',
      importe: 46.0,
      puntos: 8,
    },
    {
      fecha: '01/01/2021',
      concepto: 'GASOLINERA BILBONDO',
      importe: 55.5,
      puntos: 8,
    },
    {
      fecha: '01/01/2021',
      concepto: 'GASOLINERA VÉLEZ-MALAGA',
      importe: 30.0,
      puntos: 4,
    },
    {
      fecha: '01/01/2021',
      concepto: 'GASOLINERA VÉLEZ-MALAGA',
      importe: 56.5,
      puntos: 8,
    },
    {
      fecha: '01/01/2021',
      concepto: 'GASOLINERA LEICEAGA',
      importe: 30.0,
      puntos: 4,
    },
    {
      fecha: '01/01/2021',
      concepto: 'GASOLINERA MAX CENTER',
      importe: 20.0,
      puntos: 4,
    },
  ];

  getTravelResponse = () => {
    const data = {
      error: false,
      pojos: this.pojos,
      pageNumber: null,
      totalElements: 60,
      puntosUsuario: 10000,
    };
    return data;
  };

  getTravelResponseByDates = (from: string, to: string) => {
    const filteredPojos = this.pojos.filter((pojo) =>
      this.filter(pojo, from, to),
    );
    const data = {
      error: false,
      pojos: filteredPojos,
      pageNumber: null,
      totalElements: filteredPojos.length,
      puntosUsuario: 10000,
    };
    return data;
  };

  private filter = (pojo: any, from: string, to: string) => {
    // .endOf('month')
    const fecha = moment(pojo.fecha, 'DD/MM/YYYY');
    const tempDate = moment(to, 'YYYYMM');
    const lastDay = tempDate.endOf('month').format('DD');
    const toDate = moment(to, `YYYYMM${lastDay}`);
    const fromDate = moment(from, 'YYYYMM');

    if (
      (fecha.isAfter(fromDate) || fecha.isSame(fromDate)) &&
      (fecha.isBefore(toDate) || fecha.isSame(toDate))
    ) {
      return pojo;
    }
    return null;
  };
}
